module.exports = __webpack_public_path__ + "img/card_3.66b48edd.svg";